<mat-tree class="container" [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node class="child-node" *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-icon-button>
        <mat-icon>insert_drive_file</mat-icon>
      </button>
      {{node.name}}
    </mat-tree-node>
    <mat-tree-node class="parent-node" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}
        </mat-icon>
      </button>
      {{node.name}}
    </mat-tree-node>
</mat-tree>
  